import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type UpdatePoDTO = {
  uuid?: string
  reqBody: {
    assignee?: number | string
    status_id?: number
    date_confirmed?: string
    carrier_service_id?: string
    id?: number[]
  }
}

type ApiResponseDTO = {
  code: number
  data: any
  api_metadata: ApiMetaDataDTO
  message?: string
}

export const usePoUpdateMutation = () =>
  useMutation<unknown, ErrorDTO, UpdatePoDTO>({
    mutationFn: async (values: UpdatePoDTO) => {
      try {
        let res
        if (values.uuid) {
          res = await client.put<ApiResponseDTO>(
            `/po/update/${values.uuid}`,
            values.reqBody
          )
        } else {
          res = await client.put<ApiResponseDTO>('/po/update', values.reqBody)
        }

        // toast.success('Supplier profile is updated')

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
